import styled from 'styled-components';

export const Main = styled.main`
  display: flex;
  flex-direction: column;
`;

export const Section = styled.section`
  min-height: 100vh;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (min-width: 768px) {
    padding: 40px;
  }
`;

export const Title = styled.h1`
    font-size: 2em;
    text-align: center;
    font-family: 'Kufam', sans-serif;
`;

export const Text = styled.p`
    font-size: 1em;
    text-align: center;
    font-family: 'Poppins', sans-serif;
`;

export const Button = styled.a`
  display: inline-block;
  padding: 10px 30px;
  background-color: #F6AF15;
  color: black;
  text-align: center;
  border-radius: 30px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s;

  &:hover {
    background-color: #d59413;
    cursor: pointer;
  }
`
export const Link = styled(Text).attrs({
    as: 'a'
})`
    margin-right: 2vw;  // Space between links
    margin-left: 2vw;  // Space between links
    color: inherit;  // Ensures the links use the color from the Text styled component
    text-decoration: none;  // Removes underline from links
  
    &:hover {
      text-decoration: underline;  // Adds underline on hover for better UX
    }
  `;

export const THEME_COLORS = {
  brandPink: '#f63690',
};